/** Shared system list (scope menu, pickers, AI assistant). */
import type { SystemView } from '@uatp/shared';
import { useGet } from './query';

export interface SystemsList {
  items: SystemView[];
  /** Systems this admin can see. */
  visible: number;
  /** Systems in the tenant (lets scoped admins see "2 of 4"). */
  total: number;
}

export const SYSTEMS_ACTIVE = '/systems?status=active';

/** Active systems visible to the current admin. Pass `enabled=false` to skip fetching. */
export function useSystems(enabled = true) {
  const q = useGet<SystemsList>(enabled ? SYSTEMS_ACTIVE : null, { staleTime: 60_000 });
  return { ...q, systems: q.data?.items ?? [] };
}
